import createAxiosInstance from './http-common';

const getAll = (api: string, isAuth = true, isMultipart = false, token?: any) => {
    const axiosInstanceWithoutToken = createAxiosInstance(isAuth, isMultipart, token);

    return axiosInstanceWithoutToken.get(`/${api}`);
};

const getById = (api: string, id: any, isAuth = true, isMultipart = false, token?: any, userStatus = true) => {
    const axiosInstanceWithoutToken = createAxiosInstance(isAuth, isMultipart, token, userStatus);
    return axiosInstanceWithoutToken.get(`/${api}/${id}`);
};

const post = (api: string, data: any, isAuth = true, isMultipart = false) => {
    const axiosInstanceWithoutToken = createAxiosInstance(isAuth, isMultipart);
    return axiosInstanceWithoutToken.post(`/${api}`, data);
};

const update = (api: string, id: any, data: any, isAuth = true, isMultipart = false) => {
    const axiosInstanceWithoutToken = createAxiosInstance(isAuth, isMultipart);
    return axiosInstanceWithoutToken.put<any>(id == '' ? `/${api}` : `/${api}/${id}`, data);
};

const remove = (api: string, id: any, data: any, isAuth = true, isMultipart = false) => {
    const axiosInstanceWithoutToken = createAxiosInstance(isAuth, isMultipart);
    return axiosInstanceWithoutToken.delete<any>(`/${api}/${id}`);
};

// const removeAll = (api:string) => {
//   return http.delete<any>(`/${api}`);
// };

const APIService = {
    getAll,
    getById,
    post,
    update,
    remove,
    //   removeAll
};

export default APIService;
